import {toggle_loader, disable_loader} from '../_loader';
let LRMap = false;
let markers = [] //array to hold the map pins;

let hide_on_pan = false;

document.addEventListener("DOMContentLoaded", function() {

	let debounce = require('debounce');

	//try to find the branch search form
	let postcode = document.querySelector('input[name="origin"]') ? document.querySelector('input[name="origin"]').value : false;

	//checks whether this map is being rendered on the checkout
	let checkout = document.body.classList.contains('page-template-page-checkout');

	//if we've got the form
	if(postcode !== false) {

		//if this isn't the checkout
		if(!checkout) {

			//fetch the search form
			let search_form = document.getElementById('branch-search');

			//if we have a search form
			if(search_form) {

				//add an event listner preventing page submit
				search_form.addEventListener("submit", handle_input);
			}
		} else if(checkout) { //otherwise if we are on the checkout

			//fetch the refresh button
			let refresh_button = document.getElementById('refresh-postcode');

			//if we have a refresh button
			if(refresh_button) {

				//add a click event
				refresh_button.addEventListener("click", handle_input);
			}
		}

		if(installersMap) {
			map_height();
			window.addEventListener('resize', debounce(map_height, 100));

			//call the branch search on page load
			branch_search(true);
		}

		document.addEventListener('click', function (event) {

			if (!event.target.matches('#quicklook-toggle')) return;

			let quicklook = document.getElementById('branch-quicklook');

			if(quicklook) {
				if(quicklook.dataset.active == 'details') {
					quicklook.setAttribute('data-active', 'services');
					event.target.setAttribute('aria-label', 'Show services');
				} else {
					quicklook.setAttribute('data-active', 'details');
					event.target.setAttribute('aria-label', 'Show details');
				}
			}

		}, false);

		document.addEventListener('click', function (event) {

			if (!event.target.matches('#close-quicklook')) return;

			let search = document.getElementById('branch-search');

			if(search) {
				search.classList.remove('active');
				event.target.setAttribute('aria-label', 'Close quicklook');
			}

		}, false);

		//if this is the checkout page
		if(checkout) {

			//add an event listener to the radio buttons
			document.addEventListener('change', function (event) {

				if (!event.target.matches('.checkout-branch-select')) return;

				if(typeof event.target.dataset.marker != 'undefined') {

					google.maps.event.trigger(markers[event.target.dataset.marker], 'click');
					LRMap.setCenter(markers[event.target.dataset.marker].getPosition());
				}

			}, false);
		}
	}
});

function map_height() {
	let height = window.innerHeight - document.getElementsByTagName('header')[0].offsetHeight;
	let admin_bar = document.getElementById('wpadminbar');

	if(admin_bar) {
		height = height - admin_bar.offsetHeight;
	}

	if(height) {
		let installersMap =  document.getElementById('installersMap');
		installersMap.style.height = height + 'px';
	}
}

function handle_input(e) {
	e.preventDefault();

	let postcode_elem = document.querySelector('input[name="origin"]');
	let postcode = (postcode_elem.value).toUpperCase();

	//attempt to fetch a postcode preview item (used on checkout)
	let postcode_preview = document.getElementById('postcode-preview');

	//if we have a preview item
	if(postcode_preview) {

		//update it to reflect the newly searched postcode
		postcode_preview.innerHTML = postcode
	}

	if(postcode) {
		toggle_loader();

		if(postcode == 'N/A') {
			branch_search();
		} else {
			var xhttp = new XMLHttpRequest();
			xhttp.onreadystatechange = function() {
				if (this.status === 200) {

					if(!this.responseText || this.responseText == '') {
						return;
					}

					let coordinates = JSON.parse(this.responseText);
					let installersMap = document.getElementById('installersMap');

					if(coordinates && installersMap) {
						installersMap.setAttribute('data-lat', coordinates.lat);
						installersMap.setAttribute('data-lng', coordinates.lng);
						installersMap.setAttribute('data-endpoint', coordinates.endpoint);

						//if this isn't the page checkout
						if(!document.body.classList.contains('page-template-page-checkout')) {

							//update the URL so the user can refresh
							window.history.replaceState(null, null, '?origin=' + postcode + '&proximity=' + coordinates.proximity);
						}

						branch_search();
					}
				}
			}

			//build our endpoint path
			let installer_endpoint = installersMap.dataset.postcode + postcode;

			//if the postcode element has a preset default and the new value doesn't equal the default
			if(postcode_elem.hasAttribute("data-default") && postcode != postcode_elem.dataset.default) {

				//remove the default postcode to make way for the new one
				installer_endpoint = installer_endpoint.replace(postcode_elem.dataset.default, '');
			}

			//if the endpoint contains a double postcode
			if(installer_endpoint.includes(postcode + postcode)) {

				//replace it with a single
				installer_endpoint = installer_endpoint.replace(postcode + postcode, postcode);
			}

			xhttp.open("GET", installer_endpoint, true);
			xhttp.send();
		}
	}
}

function branch_search(update_list = true) {

	//fetch the installer map
	let installersMap = document.getElementById('installersMap');

	//check whether or not we're on a branch child page
	let branch_page = document.body.classList.contains('single-branch');

	//checks whether this map is being rendered on the checkout
	let checkout = document.body.classList.contains('page-template-page-checkout');

	//if the installer map exists
	if (typeof(installersMap) != 'undefined' && installersMap != null) {

		//use a more subtle loading animation
		installersMap.classList.add('loading-pulse');

		//attempt to fetch the HTML for the branch list, we'll clear this and re-populate after the JS request
		let branches_list = document.getElementById('branches');

		//if we have identified the branch list
		if(update_list && branches_list) {

			//clear its HTML and replace with a horizontal loader
			branches_list.innerHTML = '<span class="horizontal-loader"></span>';
		}

		let lat = 53.003644;
		let lng = -0.547859;
		let zoom = 7;

		//if we have user provided lat/lng coordinates
		if(installersMap.dataset.lat && installersMap.dataset.lng) {

			//update the lat/lng values we pass to the map
			lat = parseFloat(installersMap.dataset.lat);
			lng = parseFloat(installersMap.dataset.lng);

			zoom = 10;
		}

		LRMap = new google.maps.Map(document.getElementById("installersMap"), {
			center: {
				lat: lat,
				lng: lng
			},
			zoom: zoom,
			mapTypeControl: (branch_page || checkout) ? false : true,
			streetViewControl: false,
			mapTypeControlOptions: {
				style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
				position: google.maps.ControlPosition.TOP_RIGHT,
			},
			fullscreenControl: (branch_page || checkout) ? false : true,
			zoomControl: (branch_page || checkout) ? false : true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT,
			},
			styles:[{elementType:"geometry",stylers:[{color:"#f5f5f5"}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{elementType:"labels.text.stroke",stylers:[{color:"#f5f5f5"}]},{featureType:"administrative.land_parcel",elementType:"labels.text.fill",stylers:[{color:"#bdbdbd"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"road",elementType:"geometry",stylers:[{color:"#ffffff"}]},{featureType:"road.arterial",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#dadada"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"transit.line",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"transit.station",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#c9c9c9"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]}]
		});

		var xhttp = new XMLHttpRequest();
		xhttp.onreadystatechange = function() {

			if (this.status === 200) {
				let branches = false;

				try {
					branches = JSON.parse(xhttp.responseText);
				} catch(error) {
					//SyntaxError: Unexpected end of JSON input
					//Unsure why this is happening
				}

				var i, marker, activeMarker;

				//Include our SVG icon as a base
				var template = [
					'<?xml version="1.0"?>',
					'<svg id="Group_3634" data-name="Group 3634" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25.269" height="35" viewBox="0 0 25.269 35">',
						'<defs>',
							'<clipPath id="clip-path">',
								'<rect id="Rectangle_1233" data-name="Rectangle 1233" width="25.269" height="35" fill="none"/>',
							'</clipPath>',
						'</defs>',
						'<g id="Group_2964" data-name="Group 2964" clip-path="url(#clip-path)">',
							'<path id="Path_692" data-name="Path 692" d="M12.634,0A12.635,12.635,0,0,0,1.91,19.315L12.634,35,23.357,19.315A12.635,12.635,0,0,0,12.634,0Z" transform="translate(0)"/>',
							'<path id="Path_693" data-name="Path 693" d="M100.889,105.545a4.647,4.647,0,1,1,3.286-1.361,4.646,4.646,0,0,1-3.286,1.361" transform="translate(-88.255 -88.262)" fill="{{ color }}"/>',
						'</g>',
					'</svg>'
				].join('\n');

				//if we have access to the branches list HTML object
				if(update_list && branches_list) {

					//clear its HTML completely
					branches_list.innerHTML = '';
				}

				//if we're on the checkout, this will hold the radio list element
				let radio_list = false;

				//if we're on the checkout
				if(checkout) {

					//fetch the radio list
					radio_list = document.getElementById('branch-radio-list');

					//if we've got the radio list
					if(radio_list) {

						//clear its HTML, ready for new radio buttons
						radio_list.innerHTML = '';
					}
				}


				/**
				 Add pins for the branches
				*/
				for (i = 0; i < branches.length; i++) {

					//if we're not on the branch page OR we're on the branch page and it's the first item we're rendering
					if(!branch_page  || branch_page && i == 0) {

						//update the svg template with the colour for this branch
						var svg = template.replace('{{ color }}', branches[i]['data']['colour']);

						let default_icon ={
							url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
							scaledSize: new google.maps.Size(25, 35)
						};

						let active_icon ={
							url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
							scaledSize: new google.maps.Size(45, 50)
						};

						let marker = new google.maps.Marker({
							position: new google.maps.LatLng(branches[i]['lat'], branches[i]['lng']), //get the first and second items (latitude and longitude)
							map: LRMap,
							optimized: false,
							icon: (branch_page ? active_icon : default_icon), //if we're on the branch page this will be the only icon displayed so we show the active icon, otherwise show the default
						});

						markers.push(marker);

						// Create a hidden button for accessibility
						let ariaButton = document.createElement('button');
						ariaButton.setAttribute('aria-label', 'View details for ' + branches[i]['data']['name']);
						ariaButton.style.position = 'absolute';
						ariaButton.style.left = '-9999px';
						ariaButton.style.top = '-9999px';
						ariaButton.addEventListener('click', function() {
							google.maps.event.trigger(marker, 'click');
						});
						document.body.appendChild(ariaButton);

						//if we're not on the branch page
						if(!branch_page) {

							//add a click event to the marker
							google.maps.event.addListener(marker, 'click', (function(marker, i, svg) {
								return function() {

									//store the details of the clicked branch
									let search = document.getElementById('branch-search');
									let quicklook = document.getElementById('branch-quicklook');

									//if this is the currently active marker
									if(activeMarker == marker) {

										if(search) {

											//close quicklook
											search.classList.remove('active');
										}

										//restore default icon size
										activeMarker.setIcon(default_icon)

										//clear the active marker
										activeMarker = false;
										return;
									} else if(activeMarker && activeMarker != marker) { //otherwise if this is a new marker clicked

										//get the current icon applied
										let icon = activeMarker.getIcon();

										//reset the icon with adjusted sizes
										activeMarker.setIcon({
											url: icon.url,
											scaledSize: new google.maps.Size(25, 35)
										});
									}

									// set the icon for the clicked marker
									marker.setIcon(active_icon);

									// update the value of activeMarker
									activeMarker = marker;

									if(!checkout) {

										//establish a potential delay (to account for closing animation)
										let delay = 0;

										//if quicklook is already open
										if(search.classList.contains('active')) {

											//set the delay to account for the animation
											delay = 350;

											//close quicklook
											search.classList.remove('active');
										}

										//wait for the delay to complete (if present)
										setTimeout(function() {

											//set quicklook's content
											quicklook.innerHTML = branches[i]['quicklook'];

											//open it
											search.classList.add('active');
										}, delay);

									} else if (checkout) {
										//attempt to find a branch selector for this ID
										let branch_selector = document.getElementById(branches[i]['data']['id']);

										//if we've found it
										if(branch_selector) {

											//set it to selected
											branch_selector.checked = true;

											//attempt to find a confirmation dialogue later on in the form
											let confirmation = document.getElementById('fitting-address-confirmation');

											//if we have a confirmation dialogue and this branch has a valid address attached to it
											if(confirmation && branch_selector.dataset.address) {

												//set the address in the confirmation dialogue
												confirmation.innerHTML = branch_selector.dataset.address;
											}
										}
									}
								}
							})(marker, i, svg));

							//if we're on the checkout and we have a radio list, we need to add a radio selector
							if(checkout && radio_list) {

								//if this is the first element
								if(i === 0) {

									//automatically check it
									branches[i]['radio'] = (branches[i]['radio']).replace('required', 'checked required');

									//attempt to find a confirmation dialogue later on in the form
									let confirmation = document.getElementById('fitting-address-confirmation');

									//if we have a confirmation dialogue and this branch has a valid address attached to it
									if(confirmation && branches[i]['data']['address']) {

										//set the address in the confirmation dialogue
										confirmation.innerHTML = branches[i]['data']['address'];
									}
								}

								//append the radio button
								radio_list.innerHTML += branches[i]['radio'];

								let button = document.getElementById(branches[i]['data']['id']);

								if(button) {
									button.dataset.marker = (markers.length - 1);
								}
							}
						}

						const queryString = window.location.search;
						const urlParams = new URLSearchParams(queryString);

						//if there's been a search and this is the first branch, assume that it's the closest
						if(i == 0 && urlParams.has('origin') ) {

							//open it
							new google.maps.event.trigger( marker, 'click' );
						}
					}

					//if we have a card list to update AND we're not on a branch page OR we're on a branch page and it's not the first item
					if(update_list && (!branch_page || branch_page && i != 0)) {

						//if this branch provides some HTML to display
						if(branches_list && branches[i]['card']) {

							//add it to the list of branches
							branches_list.innerHTML += branches[i]['card'];
						}
					}
				}

				//disable the main loader if present
				disable_loader();

				//add a more subtle animation
				installersMap.classList.remove('loading-pulse');

				if(hide_on_pan) {
					google.maps.event.addListener(LRMap, "dragend", debounce(hide_markers), 150);
					google.maps.event.addListener(LRMap, "zoom_changed", debounce(hide_markers), 150);
					hide_markers();

					function hide_markers() {
						for(let i = 0; i < markers.length; i++) {
							if (LRMap.getBounds().contains(markers[i].getPosition())) {
								markers[i].setMap(LRMap);
							} else {
								markers[i].setMap(null);
							}
						}
					}
				}
			}
		};

		xhttp.open("GET", installersMap.dataset.endpoint, true);
		xhttp.send();
	}
}